const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js'

let loadPromise = null

/**
 * Load Razorpay checkout.js on demand (avoids global preload warnings on every page).
 */
export function loadRazorpayCheckout() {
  if (typeof window !== 'undefined' && typeof window.Razorpay === 'function') {
    return Promise.resolve(window.Razorpay)
  }

  if (loadPromise) {
    return loadPromise
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${RAZORPAY_SCRIPT_URL}"]`)

    if (existing) {
      if (typeof window.Razorpay === 'function') {
        resolve(window.Razorpay)
        return
      }
      existing.addEventListener('load', () => {
        if (typeof window.Razorpay === 'function') {
          resolve(window.Razorpay)
        } else {
          reject(new Error('Razorpay failed to initialize'))
        }
      })
      existing.addEventListener('error', () => {
        reject(new Error('Failed to load Razorpay checkout'))
      })
      return
    }

    const script = document.createElement('script')
    script.src = RAZORPAY_SCRIPT_URL
    script.async = true
    script.onload = () => {
      if (typeof window.Razorpay === 'function') {
        resolve(window.Razorpay)
      } else {
        reject(new Error('Razorpay failed to initialize'))
      }
    }
    script.onerror = () => {
      loadPromise = null
      reject(new Error('Failed to load Razorpay checkout'))
    }
    document.head.appendChild(script)
  })

  return loadPromise
}
